<template>
    <el-image class="" :style="styleObj" :src="filePath" :preview-src-list="srcList">
    </el-image>
</template>

<script>
export default {
    name: 'fileImage',
    props: {
        fileData: {
            type: String,
            default: '',
        },
        styleObj: {
            type: Object,
            default: {
                width: '6.25rem',
                height: '6.25rem'
            }

        }
    },
    components: {
    },
    data() {
        return {
            srcList: [],
            filePath: '',
        }
    },
    created() {
        this.getFileData();
    },
    methods: {
        // 处理图片数据
        getFileData() {
            if (this.fileData != '') {
                let tempFile = JSON.parse(this.fileData);
                if (tempFile.length > 0) {
                    let temp = [];
                    tempFile.forEach((item) => {
                        temp.push(localStorage.getItem('filePath') + item.url)
                    })
                    this.srcList = temp;
                    this.filePath = this.srcList[0];
                }
            }
        }
    }
}
</script>

<style scoped>
.img_size {
    width: 100px;
    height: 100px;
}
</style>